
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useEffect, useState } from "react";

interface WelcomeMessageProps {
  primaryColor?: string;
  secondaryColor?: string;
}

export const WelcomeMessage = ({ 
  primaryColor = '#4B89FF',
  secondaryColor = '#7E69AB' 
}: WelcomeMessageProps) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <motion.div
      initial={{ opacity: 0, x: 20, scale: 0.9 }}
      animate={{ opacity: 1, x: 0, scale: 1 }}
      exit={{ opacity: 0, x: 20, scale: 0.9 }}
      className="relative group"
    >
      <div 
        className="absolute inset-0 rounded-full blur-xl"
        style={{
          background: `linear-gradient(to r, ${primaryColor}20, ${secondaryColor}20)`
        }}
      />
      <span className="relative px-5 py-2.5 bg-white/90 backdrop-blur-sm rounded-full text-sm font-medium text-gray-700 shadow-lg border border-blue-100/50 flex items-center gap-2">
        <MessageCircle className="w-4 h-4" style={{ color: primaryColor }} />
        Let's Connect
        <motion.span
          animate={{ x: [0, 5, 0] }}
          transition={{ repeat: Infinity, duration: 1.5 }}
          style={{ color: secondaryColor }}
        >
          →
        </motion.span>
      </span>
    </motion.div>
  );
};
